// Product quantity selector with +/- buttons
(function() {
  function initQuantitySelector() {
    // Wait for jQuery to be available
    if (typeof jQuery === 'undefined') {
      setTimeout(initQuantitySelector, 100);
      return;
    }

    jQuery(document).ready(function($) {
      // Find all quantity selectors
      $('.product-quantity-selector').each(function() {
        const $container = $(this);
        const $input = $container.find('input[name="quantity"]');
        const $minusBtn = $container.find('.product-quantity-btn--minus');
        const $plusBtn = $container.find('.product-quantity-btn--plus');

        // Update minus button disabled state
        function updateButtonState() {
          let currentValue = parseInt($input.val()) || 1;
          if (currentValue <= 1) {
            $minusBtn.prop('disabled', true);
          } else {
            $minusBtn.prop('disabled', false);
          }
        }

        // Ensure input value is at least 1
        function ensureMinimum() {
          let currentValue = parseInt($input.val()) || 1;
          if (currentValue < 1) {
            currentValue = 1;
            $input.val(currentValue);
          }
          updateButtonState();
          return currentValue;
        }

        // Update input value and trigger change event
        function updateQuantity(newValue) {
          if (newValue < 1) newValue = 1;
          $input.val(newValue);
          updateButtonState();
          $input.trigger('change');
        }

        // Minus button click handler
        $minusBtn.on('click', function(e) {
          e.preventDefault();
          if ($(this).prop('disabled')) return;
          let currentValue = parseInt($input.val()) || 1;
          if (currentValue > 1) {
            updateQuantity(currentValue - 1);
          }
        });

        // Plus button click handler
        $plusBtn.on('click', function(e) {
          e.preventDefault();
          let currentValue = parseInt($input.val()) || 1;
          updateQuantity(currentValue + 1);
        });

        // Handle direct input changes
        $input.on('input blur change', function() {
          ensureMinimum();
        });

        // Ensure value is valid on page load
        ensureMinimum();
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuantitySelector);
  } else {
    initQuantitySelector();
  }
})();
